
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"112.502","height":"50.944","viewBox":"0 0 112.502 50.944"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"id":"backDrop","d":"M101.889 50.944H10.613A10.51 10.51 0 010 40.331V10.613A10.51 10.51 0 0110.613 0h91.275A10.51 10.51 0 01112.5 10.613v29.718a10.51 10.51 0 01-10.611 10.613z","fill":"#292e35"}}),_c('circle',{staticClass:"b",attrs:{"id":"blank","cx":"13.373","cy":"13.373","transform":"translate(40.331 12.099)","r":"13.373"}}),_c('circle',{staticClass:"b",attrs:{"id":"blank","cx":"13.373","cy":"13.373","transform":"translate(9.34 12.099)","r":"13.373"}}),_c('g',{attrs:{"transform":"translate(67.714 8.278)"}},[_c('circle',{attrs:{"cx":"17.194","cy":"17.194","opacity":".2","fill":"#18db38","r":"17.194"}}),_c('path',{attrs:{"d":"M17.194 3.821A13.373 13.373 0 113.821 17.194 13.373 13.373 0 0117.194 3.821z","fill":"#18db38"}}),_c('path',{staticClass:"b",attrs:{"d":"M16.132 21.651a1.291 1.291 0 01-1.7 0l-2.972-2.972a1.291 1.291 0 010-1.7 1.291 1.291 0 011.7 0l2.972 2.972a1.291 1.291 0 010 1.7z"}}),_c('path',{staticClass:"b",attrs:{"d":"M14.858 21.652a1.291 1.291 0 010-1.7l7.217-7.217a1.291 1.291 0 011.7 0 1.291 1.291 0 010 1.7l-7.217 7.217a1.291 1.291 0 01-1.7 0z"}})])])
          )
        }
      }
    